var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.routerLink)?_c('a',{class:_vm.classes,attrs:{"href":_vm.hrefLink,"target":_vm.target,"rel":_vm.target === '_blank' ? 'noopener' : _vm.rel}},[_vm._t("text"),_vm._t("icon")],2):_c('router-link',{attrs:{"to":{ name: _vm.hrefLink }}},[_vm._t("text"),_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }